"use client";

import { ActionForm, Field, SubmitButton } from "@/components/ui/form";
import { useT } from "@/components/i18n-ui/provider";
import { submitContactTicket } from "./actions";

export function ContactForm({ sites }: { sites: { id: string; name: string }[] }) {
  const t = useT("marketing");
  return (
    <ActionForm action={submitContactTicket} resetOnSuccess refresh={false} className="space-y-5">
      <Field label={t("contact.form.subject")} name="subject">
        <input id="subject" name="subject" className="input" required maxLength={200} placeholder={t("contact.form.subjectPlaceholder")} />
      </Field>
      {sites.length > 0 && (
        <Field label={t("contact.form.website")} name="siteId">
          <select id="siteId" name="siteId" className="input" defaultValue="">
            <option value="">{t("contact.form.noWebsite")}</option>
            {sites.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </Field>
      )}
      <Field label={t("contact.form.body")} name="body" hint={t("contact.form.bodyHint")}>
        <textarea id="body" name="body" className="input min-h-[160px]" required minLength={10} maxLength={5000} />
      </Field>
      <SubmitButton pendingText={t("contact.form.sending")}>{t("contact.form.submit")}</SubmitButton>
    </ActionForm>
  );
}
